import Control from "ol/control/Control";
import { ToolbarButtonGroup } from "./buttons";
export class Toolbar extends Control {
    constructor(opt_options) {
        const elem = document.createElement('div');
        elem.className = 'toolBar ol-unselectable ol-control';
        opt_options.element = elem;
        super(opt_options);
        this.ui = $(elem);
        this.buttons = opt_options.buttons || [];
        this.initialize_ui();
        this.default_img = $('<i class="fas fa-object-group" title="Group Selection Options"></i>');
    }
    initialize_ui() {
        for (let button of this.buttons) {
            this.ui.append(button.ui);
        }
    }
    add_buttons(...buttons) {
        let skip = false;
        for (let btn of buttons) {
            if (btn.buttonGroup !== ToolbarButtonGroup.Group) {
                this.buttons.push(btn);
                this.ui.append(btn.ui);
            }
            else {
                if (!skip) {
                    this.ui.append($('<span id="group_placeholder"></span>'));
                    skip = true;
                }
            }
        }
        const group_buttons = buttons.filter(x => x.buttonGroup === ToolbarButtonGroup.Group);
        if (group_buttons.length) {
            let group_div = this.create_group_ui(group_buttons);
            this.ui.find("#group_placeholder").replaceWith(group_div);
        }
        else {
            this.ui.find("#group_placeholder").remove();
        }
    }
    create_group_ui(group_buttons) {
        const group_div = $('<div class="toolbar-btn-group"></div>');
        const display_button = $('<button class="display-btn"></button>');
        display_button.append(this.default_img);
        const dropdown_button = $('<button class="dropdown-btn"><i class="fas fa-sort"></i></button>');
        const dropdown_content = $('<div class="dropdown-content"></div>');
        group_div.append(display_button);
        group_buttons.forEach(b => {
            dropdown_content.append(b.ui);
            b.ui.on("click", (_) => {
                dropdown_content.toggle();
                if (dropdown_content.next('label').length > 0) {
                    dropdown_content.next('label').text(b.title);
                }
                else {
                    let label = $(`<label style="margin-right:4px; margin-left:1px; cursor:pointer;">${b.title}</label>`);
                    dropdown_content.after(label);
                    label.on("click", (_) => {
                        dropdown_content.toggle();
                    });
                }
                let img = b.ui.find('svg');
                if (img.length) {
                    display_button.empty();
                    display_button.append(img.clone());
                }
            });
        });
        group_div.append(dropdown_content);
        group_div.append(dropdown_button);
        display_button.on("click", (_) => {
            dropdown_content.toggle();
        });
        dropdown_button.on("click", (_) => {
            dropdown_content.toggle();
        });
        $(document).on('group_interaction_cancelled', () => {
            dropdown_content.next('label').remove();
            display_button.empty();
            display_button.append(this.default_img);
        });
        return group_div;
    }
}
